import React from 'react'
import { Link } from 'react-router'

import { AlertTriangle, Clock } from 'lucide-react'

import type { AlertasInactividad as AlertasInactividadType } from '@/types/dashboard_stats.types'

interface AlertasInactividadProps {
  alertas: AlertasInactividadType
  umbralDias: number
  onUmbralChange: (dias: number) => void
}

const FASE_LABELS: Record<string, string> = {
  'current-level': 'Nivel actual',
  'gap-analysis': 'Análisis de brechas',
  recommendations: 'Recomendaciones',
  planning: 'Planificación'
}

export const AlertasInactividad: React.FC<AlertasInactividadProps> = ({
  alertas,
  umbralDias,
  onUmbralChange
}) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Clock className="h-4 w-4 text-amber-600" />
          <h3 className="text-sm font-semibold text-gray-700">
            Alertas de inactividad
            {alertas.total > 0 && (
              <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800">
                {alertas.total}
              </span>
            )}
          </h3>
        </div>
        <div className="flex items-center gap-2 text-xs text-gray-500">
          <span>Sin actividad en más de</span>
          <input
            type="number"
            min={1}
            max={365}
            value={umbralDias}
            onChange={(e) => onUmbralChange(Number(e.target.value))}
            className="w-14 border border-gray-300 rounded px-2 py-0.5 text-xs text-center focus:outline-none focus:ring-1 focus:ring-primary-400"
          />
          <span>días</span>
        </div>
      </div>

      {alertas.total === 0 ? (
        <p className="text-sm text-gray-400 italic">
          No hay assessments sin actividad superior a {umbralDias} días.
        </p>
      ) : (
        <div className="space-y-2">
          {alertas.items.map((item) => (
            <div
              key={item.assessment_id}
              className="flex items-center justify-between bg-amber-50 border border-amber-200 rounded-lg px-4 py-3"
            >
              <div className="min-w-0">
                <Link
                  to={`/assessments/${item.assessment_id}/dashboard`}
                  className="text-sm font-medium text-gray-900 hover:text-primary-600 truncate block"
                >
                  {item.nombre}
                </Link>
                <p className="text-xs text-gray-500">
                  {item.organizacion_nombre} · {FASE_LABELS[item.fase_actual] ?? item.fase_actual}
                </p>
              </div>
              <div className="flex items-center gap-1 ml-4 shrink-0">
                <AlertTriangle className="h-3 w-3 text-amber-600" />
                <span className="text-xs font-semibold text-amber-700">
                  {item.dias_sin_actividad}d sin actividad
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
